import { camelize } from 'transformer/common';

const listDoctorsDataTransformer = (data) => {
    return camelize(data);
};

export { listDoctorsDataTransformer };
